import React from 'react';
import { HomeMosaic } from './dashboard/HomeMosaic';
import { People } from './dashboard/People';
import { Archive } from './dashboard/Archive';
import { Voices } from './dashboard/Voices';
import { Profile } from './dashboard/Profile';
import { MemorialProfile } from './dashboard/MemorialProfile';
import type { PortalSection } from '../components/layout/AppShell';
import type { Member } from '../data/community';
interface DashboardProps {
  section: PortalSection;
  sparse: boolean;
  onNavigate: (section: PortalSection) => void;
  profileOf: Member | null;
  onOpenProfile: (member: Member) => void;
}
export function Dashboard({
  section,
  sparse,
  onNavigate,
  profileOf,
  onOpenProfile
}: DashboardProps) {
  if (section === 'profile' && profileOf) {
    if (profileOf.memorial) {
      return <MemorialProfile member={profileOf} onBack={() => onNavigate('people')} data-id="element-546" data-mp="1wclsnl7p0ujf" />;
    }
    return <Profile member={profileOf} onBack={() => onNavigate('people')} data-id="element-547" data-mp="1reai189kqg05" />;
  }
  if (section === 'people') return <People sparse={sparse} onOpenProfile={onOpenProfile} data-id="element-548" data-mp="21q6iw8afknj6" />;
  if (section === 'archive') return <Archive data-id="element-549" data-mp="26ohschwtcw0v" />;
  if (section === 'voices') return <Voices data-id="element-550" data-mp="26n6pckb6zsat" />;
  return <HomeMosaic sparse={sparse} onOpenPeople={() => onNavigate('people')} data-id="element-551" data-mp="26quhbf0zo6nf" />;
}